import React from 'react';
import {pageData} from '../../constants/pagedata';
import {PagePicker} from '../../components/pagepicker';
import { ContentPicker } from '../../components/contentpicker';
import {EmbedWrapper} from './embedwrapper';
import { ALL_GAMES_LIST } from '../../constants/textcontent';

const EMBED_INTRO:string="Embed Page";

const CHOOSE_MSG:string="Choose a page";

interface StateType{
	pageSelected:string,
	contentSelected:string[],
	testEmbed:boolean
}

interface PropsType{
	usermail:string,
	userContentList:string[]
}

export default class Embed extends React.Component<PropsType>{

	public state:StateType;

	constructor(props:PropsType){
		super(props);
		this.state={
			pageSelected:'',
			contentSelected:['',''],
			testEmbed:false
		}
		this.pageClick=this.pageClick.bind(this);
		this.contentClick=this.contentClick.bind(this);
		this.embedTestClick=this.embedTestClick.bind(this);
	}

	pageClick(pageClicked:string){
		if(pageClicked!==this.state.pageSelected){
			this.setState({pageSelected:pageClicked,contentSelected:['','']});
		}else{//deselect
			this.setState({pageSelected:'',contentSelected:['','']});
		}
	}
  
	contentClick(contentSelected:string[]){
		if(contentSelected[0]===this.state.contentSelected[0]&&contentSelected[1]===this.state.contentSelected[1]){
			this.setState({contentSelected:['','']});
		}else{
			this.setState({contentSelected:contentSelected});
		}
	}

	embedTestClick(){
		this.setState({testEmbed:true});
	}

	render() {
		let contentGroup=0;
		if(this.state.pageSelected!=='')contentGroup=pageData[this.state.pageSelected].contentGroup;
		let showChooseContentMsg=contentGroup!==0;
		return (
			<div id='teachers-embed'>
				<hr />
				<h3>{EMBED_INTRO}</h3>
				<p>If you have a webpage, blog or online course, you can use this page to generate code to embed games from this site.  The games will display as they normally do and be fully interactive.  You can alter the <i>max-width</i> and <i>height</i> values to change the size of the window that appears.  If you have uploaded a set of images, you can select those images to be used with the game that you embed.  It is recommended that you click <b>Test</b> to check the embed code before you add it to your site.</p>
				<h4>{CHOOSE_MSG}</h4>
				<PagePicker
					pageClick={this.pageClick} 
					pageSelected={this.state.pageSelected}
					showList={ALL_GAMES_LIST} />
				{showChooseContentMsg&&<hr />}
				{showChooseContentMsg&&<h4>Choose content to use</h4>}
				<ContentPicker
					pageSelected={this.state.pageSelected}
					contentClick={this.contentClick}
					userContentList={this.props.userContentList}
					contentSelected={this.state.contentSelected}/>
				<hr />
				<EmbedWrapper
					pageSelected={this.state.pageSelected}
					usermail={this.props.usermail}
					contentSelected={this.state.contentSelected}
					embedTestClick={this.embedTestClick}
					testEmbed={this.state.testEmbed}/>
			</div>
		);
	}
}
